// extracted by mini-css-extract-plugin
export default {"paginationWrapper":"styles_paginationWrapper__sODaC","dataShow":"styles_dataShow__0ZGZt","paginationElement":"styles_paginationElement__HFZCA"};